import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;

const OverlayContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 80%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
  &:hover {
    color: #666;
  }
`;

const FieldContainer = styled.div`
  margin-bottom: 10px;
  padding: 5px;
  border-bottom: 1px solid #eee;
  white-space: pre-wrap;
  word-break: break-all;
  
  &:last-child {
    border-bottom: none;
  }
`;

const FieldLabel = styled.span`
  font-weight: bold;
  margin-right: 10px;
  color: #666;
`;

const ActionDetailsOverlay = ({ row, onClose }) => {
  const formatValue = (value) => {
    if (value === null || value === undefined) return 'N/A';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    return String(value);
  };

  return (
    <OverlayContainer onClick={onClose}>
      <OverlayContent onClick={e => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <h3>Action Details</h3>
        {Object.entries(row).map(([key, value]) => (
          <FieldContainer key={key}>
            <FieldLabel>{key}:</FieldLabel>
            <span>{formatValue(value)}</span>
          </FieldContainer>
        ))}
      </OverlayContent>
    </OverlayContainer>
  );
};

ActionDetailsOverlay.propTypes = {
  row: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ActionDetailsOverlay;